function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React from 'react';
import NavigationBase from './NavigationBase';
import classNames from 'classnames';

function Navigation(props) {
  var navigationClasses = classNames(props.className);
  return /*#__PURE__*/React.createElement(NavigationBase, _extends({}, props, {
    className: navigationClasses
  }));
}

Navigation.propTypes = _extends({}, NavigationBase.propTypes, {
  /** Adds divider line beneath the navigation */
  withBorder: PropTypes.bool,

  /** Left align. */
  leftAlign: PropTypes.bool
});
Navigation.defaultProps = _extends({}, NavigationBase.defaultProps, {
  withBorder: false,
  leftAlign: true
});
export default Navigation; // eslint-disable-line new-cap
//# sourceMappingURL=Navigation.js.map